<template>
  <svg
    @click="$emit('click', $event)"
    class="transform transition transform ease-in duration-200 cursor-pointer"
    :class="iconDirection"
    :width="width"
    :height="height"
    viewBox="0 0 11 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.70765 5.12204L9.82969 1L10.4163 1.58467L5.99904 6H5.41437L0.999987 1.58467L1.58561 1L5.70765 5.12204Z"
      fill="#6B6B74"
      stroke="#6B6B74"
      stroke-width="0.5"
    />
  </svg>
</template>

<script>
export default {
    name: "ArrowIcon",
    props: ['width', 'height', 'direction'],
    computed: {
        iconDirection() {
            let directionClass;

            switch(this.direction) {
                case 'top':
                    directionClass = 'rotate-180';
                    break

                case 'right':
                    directionClass = '-rotate-90';
                    break

                case 'bottom':
                    directionClass = 'rotate-0';
                    break

                case 'left':
                    directionClass = 'rotate-90';
                    break

                default:
                    directionClass = 'rotate-0';
                    
            }

            return directionClass;
        }
    }
};
</script>

<style></style>
